import { BannerCarousel, CommonSelect, CstmPagination } from 'components/Common/Common'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import CaseloadSchool from 'components/shared/caseLoad/CaseloadSchool'
import ErrorComponent from 'components/shared/ErrorComponent'
import AppInputField from 'components/shared/FormComponents/AppInputField'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayoutV2 from 'components/TableLayoutV2'
import { GRADE_OPTIONS, TASK_STATUS_OPTIONS_V2 } from 'config/constants'
import { CASELOAD_TASK } from 'config/paths'
import { dateFormat, successMessageToast, userFullName } from 'helpers/common'
import { usePersistentState } from 'hooks/usePersistentState'
import { debounce } from 'lodash'
import React, { useCallback, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { ChevronLeft, ChevronRight, Download, Star } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFavouriteTaskPlanMutation, useGetCaseloadDataQuery } from 'store/services/myCaseload'
import { useBulkDownloadReportsMutation, useFavouriteReportMutation, useGetReportsListQuery } from 'store/services/resource'
import { useGetActiveSchoolBannersListQuery } from 'store/services/schoolBanners.service'
import { useDisciplinesLookupQuery, useLazyGetFileUrlQuery } from 'store/services/utility'
import { useUpdateTaskStatusMutation } from 'store/services/V2/TaskPlan'
import { taskPlanFilter } from 'store/slices/filter';

// ─── Banner Carousel ──────────────────────────────────────────────────────────

const BANNER_SLIDES = [
  {
    id: 1,
    header: "Banner Header",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    linkLabel: "Link",
    linkHref: "#",
  },
  {
    id: 2,
    header: "Banner Header",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    linkLabel: "Link",
    linkHref: "#",
  },
  {
    id: 3,
    header: "Banner Header",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    linkLabel: "Link",
    linkHref: "#",
  },
];


// ─── Main Component ───────────────────────────────────────────────────────────

function MyCaseload() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [modalType, setModalType] = useState(null);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");

  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = usePersistentState("taskplan:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.taskPlanFilter);

  const { id } = useParams()

  const { data, isLoading, isError, isFetching, refetch } = useGetReportsListQuery(
    { page: currentPage, limit: pageSize, id, ...filter },
    { refetchOnMountOrArgChange: true }
  );
  const { data: disciplineOptions, isLoading: disciplineOptionsLoading } = useDisciplinesLookupQuery()
  const disciplines = disciplineOptions?.map((item) => ({ label: item?.assign_term, value: item?.id }))

  const reportsList = data?.records || [];
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [favouriteTaskPlan, { isLoading: favouriteTaskLoading }] = useFavouriteReportMutation()
  const [updateTaskStatus, { isLoading: statusLoading }] = useUpdateTaskStatusMutation()
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
  const { data: bannersList, isLoading: bannersLoading, isFetching: bannersFetching } = useGetActiveSchoolBannersListQuery()
  const [bulkDownloadReports, { isLoading: bulkDownloadLoading }] = useBulkDownloadReportsMutation()

  const handleBulkDownload = async () => {
    try {
      const resp = await bulkDownloadReports({ id }).unwrap()
      successMessageToast(resp?.message)
    } catch (err) {
      console.error("Error downloading reports", err);
    }
  }

  const handleViewPdf = async (name) => {

    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(taskPlanFilter({ ...filter, [key]: value }))
    setCurrentPage(1);
  };

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const handleGetRowColor = (item) => {
    if (item?.status == "pending") {
      return "rowYellow";
    }
    else if (item?.status == "inactive") {
      return "rowGray";
    }
  }

  const handleFavouriteReport = async (id, favorite) => {
    const data = { favorite }
    try {
      await favouriteTaskPlan({ data, id }).unwrap()
    } catch (error) {
      console.error('error making the client favourite: ', error)
    }
    refetch()
  }

  const handleUpdateStatus = async () => {
    setIsStatusModal(false)
    try {
      const resp = await updateTaskStatus({
        id: currentEntry?.id,
        payload: { status: newStatus },
      });
      if (resp.data.status === "success") {
        successMessageToast(resp?.data?.message)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const column = [
    {
      head: <div onClick={() => dispatch(taskPlanFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
          <div className="cursor-pointer" onClick={(e) => {
            e.stopPropagation();
            handleFavouriteReport(item?.assesmentResources?.id, item?.is_favorite ? 0 : 1)
          }}>
            {item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}
          </div>
        </h6>
      ),
    },
    {
      head: "DATE",
      accessor: "date",
      isComponent: true,
      sorter: true,
      component: (item) => dateFormat(item?.createdAt, "MMM DD, YYYY"),
    },
    {
      head: "GR.",
      accessor: "client_grade",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.clientResources?.client_detail?.grade}
          </h6>
        )
      }
    },
    {
      head: "DISC.",
      accessor: "discipline",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            <span style={{ borderRadius: '8px', padding: "7px 10px" }} className={`discipline-${item?.therapistResources?.therapist_detail?.therapist_discipline?.assign_term}-capsule-bcg`}>
              {item?.therapistResources?.therapist_detail?.therapist_discipline?.assign_term}
            </span>
          </h6>
        )
      }
    },
    {
      head: "CLIENT",
      accessor: "client_id",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        const clientName = userFullName(item?.clientResources)
        return (
          <div>
            <span>{clientName}</span>
          </div>
        )
      },
    },
    {
      head: "REPORT TYPE",
      accessor: "attachment_name",
      isComponent: true,
      sorter: true,
      width: "100%",
    },
    {
      head: "",
      accessor: "download",
      isComponent: true,
      // sorter: true,
      component: (item) => {
        return (
          <Download style={{ cursor: "pointer" }} onClick={() => handleViewPdf(item?.attachment_key)} color='#93278f' />
        )
      }
    },
  ];

  return (
    <>
      <ConfirmationPop
        confirmation={isStatusModal}
        setConfirmation={setIsStatusModal}
        confirmHandler={handleUpdateStatus}
        type={modalType}
      />

      <section className='client position-relative py-4 px-2 min-vh-100' style={{ background: "#3DA0AA0D" }}>

        {/* ── Banner Carousel ── */}
        {/* ── Banner Carousel ── */}
        <BannerCarousel />
        <Container fluid>
          {(isLoading || bannersLoading) ? (
            <div style={{ height: "200px" }}>
              <LoadingIndicator />
            </div>
          ) : (
            <Col className='col-lg-10'>
              {/* <CaseloadSchool caseloadData={caseloadSchoolData?.record} /> */}
              <div style={{ justifyContent: 'space-between' }} className='left classroom-conslutation d-flex justify-content-between align-items-end mt-4'>
                {/* <h6 className="m-0 fw-bold main-head themeBlue">REPORTS</h6> */}
                <Col lg="6">
                  <Row>
                    <Col xs="6" md='5'>
                      <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                        <label className="discharge-screen-label mb-0 ">GRADE</label>
                        <CommonSelect
                          placeholder={"Select"}
                          option={GRADE_OPTIONS}
                          onChange={(e) => handleFilterChange("grade")(e)}
                          value={filter?.grade}
                          isFilterV2
                          isClearable
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "100%",
                            }),
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs="6" md='6'>
                      <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                        <label className="discharge-screen-label mb-0">DISCIPLINE</label>
                        <CommonSelect
                          placeholder={"Select"}
                          option={disciplines}
                          onChange={(e) => handleFilterChange("discipline")(e)}
                          value={filter?.discipline}
                          isFilterV2
                          isClearable
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "100%",
                            }),
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs="4" md='4'>
                  <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0 text-end">SEARCH</label>
                    <input
                      type="text"
                      style={{ borderRadius: "8px", height: "30px" }}
                      placeholder='Type to search...'
                      className="read-only form-control w-100"
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                  </div>
                </Col>
              </div>
              <Col lg='12 mt-4 text-end'>
                <div className='d-flex justify-content-end'>
                  <button
                    onClick={() => handleBulkDownload()}
                    disabled={getFileLoading || isFetching || bulkDownloadLoading || reportsList?.length == 0}
                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                  // isLoading={submitReportLoading || submitting}
                  >
                    Download All Reports
                  </button>
                </div>
              </Col>

              <div className="table-outer mt-3">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || favouriteTaskLoading || getFileFetching || statusLoading || bannersFetching || bulkDownloadLoading) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={reportsList}
                      column={column}
                      filter={filter}
                      // handleRowClick={(row) => {
                      //   navigate(
                      //     CASELOAD_TASK.replace(
                      //       "/:taskPlanId/:clientId",
                      //       `/${row?.id}/${row?.client_id}`
                      //     )
                      //   );
                      // }}
                      handleSort={handleFilterChange("sort")}
                      handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          )}
        </Container>
      </section>
    </>
  )
}

export default MyCaseload